import { useDraftScheduleReviewDecisionByAmendsKey } from "./use-draft-schedule-review-decision-by-amends-key"

export function useReviewDecisionByAmendsKey({ projectId, scheduleId, reviewCycle } = {}) {
    const draftScheduleReviewDecisionByAmendsKey = useDraftScheduleReviewDecisionByAmendsKey({
        projectId,
        scheduleId,
        reviewCycle,
    })

    return draftScheduleReviewDecisionByAmendsKey
}
